@if (isLoaded) { @for (setting of eventLogSettings; track setting.type) {
<div class="events-log-panel">
  @for (alertSubType of setting.alertSubTypes; track alertSubType.name) {
  <lin-card>
    <lin-card-title>{{ alertSubType.name }}</lin-card-title>
    @for (event of alertSubType.events; track event.id) {
    <lin-card-content [routerLink]="getUrl(event.id)" [queryParams]="{ eventTeam: setting.type, eventId: event.id }">
      {{ event.alias }} {{ getEventCount(event) }}
    </lin-card-content>
    }
  </lin-card>
  }
</div>
} } @if (!isLoaded) {
<lin-spinner></lin-spinner>
}
